var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"ecology-main"},[(!_vm.loading)?_c('div',{staticClass:"content"},[_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }